// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/index.js??ref--7-1!../../node_modules/postcss-loader/lib/index.js??ref--7-2!../../node_modules/less-loader/dist/cjs.js??ref--7-3!./nec_funcs.less");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js")("34c19aea", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./static/css/nec_funcs.less
// module id = uqb5
// module chunks = 4